import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import CONFIG from "@rentiohq/shared/dist/config/app.config";

export const Wrap = styled.div`
  align-self: center;
  padding-left: 16px;
  padding-right: 16px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const InnerWrap = styled.div`
  background-color: white;
  width: auto;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  padding-top: 24px;
  padding-bottom: 24px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const HeaderWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: 16px;
  margin-right: 16px;
`;

export const HeaderLogo = styled.img`
  width: 100px;
  height: 25px;
`;

export const HeaderTitle = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.global2};
`;

export const Value = styled.span`
  font-size: 14px;
  font-weight: bold;
  font-family: ${props => props.theme.fonts.financial};
  color: ${props => props.theme.colors.neutral1};
`;

export const TotalTitle = styled.span`
  font-size: 15px;
  font-weight: bold;
  color: ${props => props.theme.colors.neutral1};
`;

export const TotalValue = styled.span`
  font-size: 17px;
  font-weight: bold;
  font-family: ${props => props.theme.fonts.financial};
  color: ${props => props.theme.colors.neutral1};
`;

export const PayDateInfoWrap = styled.div`
  margin: 0 auto;
  max-width: 480px;
  align-items: center;
  flex-direction: column;
  display: flex;
`;

export const PayBeforeDate = styled.span`
  display: block;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: ${props => props.theme.colors.global1};
`;

export const PayCompletedDate = styled.span`
  display: block;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.warningText};
`;

export const PaymentMethodIconWrap = styled.div`
  align-items: center;
  flex-direction: row;
  display: flex;
  margin-top: 8px;
`;

export const ListItemSeparatorWrap = styled.div`
  margin-left: 16px;
  margin-right: 16px;
`;
